import axios from '../../api/config/axios';

// Estado inicial
const state = () => ({
    user: null,
    error: null,
});

// Getters
const getters = {
    user: state => state.user,
    error: state => state.error,
};

// Actions
const actions = {
    async getUser({ commit }) {
        try {
            const response = await axios.get('/api/v1/user');
            commit('setUser', response.data.data);
        } catch (error) {
            commit('setError', error.response.data);
            console.error('getUser error:', error);
            throw error;
        }
    },
    async salvarUser({ commit, state }) {
        commit('setError', null);
        try {
            const response =  await axios.post('/api/v1/user', state.user);
            commit('setUser', response.data.data);
            return response.data.data.id;
        } catch (error) {
            commit('setError', error.response.data);
            console.error('Registration error:', error);
            throw error;
        }
    },
    async atualizarUser({ commit, state }) {
        commit('setError', null);
        try {
            const response = await axios.put(`/api/v1/user/${state.user.id}`, state.user);
            commit('setUser', response.data.data);
        } catch (error) {
            commit('setError', error.response.data);
            console.error('Update error:', error);
            throw error;
        }
    },
    async completarCadastro({ commit, state }) {
        commit('setLoading', true, { root: true });
        commit('setError', null);
        try {
            const response = await axios.post('/api/v1/completar-cadastro', state.user);
            commit('setLoading', false, { root: true });
            return response.data;
        } catch (error) {
            commit('setLoading', false, { root: true });
            commit('setError', 'Erro ao completar cadastro. Por favor, tente novamente.');
            console.error('Registration error:', error);
            throw error;
        }
    },
};

// Mutations
const mutations = {
    setUser(state, user) {
        state.user = user;
    },
    setError(state, error) {
        state.error = error;
    },
};

// Exporta o módulo
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
